import React, { useState } from "react";
import { Box, TextField, Typography, Modal } from "@mui/material";
import { styled } from "@mui/material/styles";
import { SaveButton, CloseButton } from "../../../common/Buttons";

const ModalContainer = styled(Box)(({ theme }) => ({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  backgroundColor: theme.palette.background.paper,
  borderRadius: "8px",
  boxShadow: 24,
  padding: theme.spacing(4),
}));

function CreateItemModal({ table, handleAddItem, openSnackbar }) {
  const [validationErrors, setValidationErrors] = useState({
    safety_stock: false,
  });
  const validateSafetyStock = (value) => {
    if (value === "" || value === null || value === undefined) return false;
    const numValue = parseInt(value, 10);
    return !isNaN(numValue) && numValue >= 0 && Number.isInteger(numValue);
  };
  const handleSafetyStockChange = (e) => {
    const value = e.target.value;
    if (value === "" || /^\d+$/.test(value)) {
      table.setCreatingRow({
        ...table.getState().creatingRow,
        safety_stock: value,
      });
      setValidationErrors({
        ...validationErrors,
        safety_stock: !validateSafetyStock(value),
      });
    }
  };
  const handleSave = () => {
    const values = table.getState().creatingRow;
    if (!values.item_name?.trim()) {
      openSnackbar("Item 이름을 입력해 주세요.", "warning");
      return;
    }
    if (!values.safety_stock) {
      openSnackbar("안전재고를 입력해 주세요.", "warning");
      return;
    }
    if (!validateSafetyStock(values.safety_stock)) {
      openSnackbar("안전재고는 0 이상의 정수여야 합니다.", "warning");
      return;
    }
    handleAddItem({ values, table });
  };
  return (
    <Modal open={true}>
      <ModalContainer>
        <Typography variant="h6" component="h2" mb={3}>
          Item 추가
        </Typography>
        <TextField
          label="Item 코드"
          fullWidth
          autoFocus
          name="item_code"
          onChange={(e) =>
            table.setCreatingRow({
              ...table.getState().creatingRow,
              item_code: e.target.value,
            })
          }
          sx={{ mb: 3 }}
        />
        <TextField
          label="Item 이름"
          fullWidth
          name="item_name"
          onChange={(e) =>
            table.setCreatingRow({
              ...table.getState().creatingRow,
              item_name: e.target.value,
            })
          }
          sx={{ mb: 3 }}
        />
        <TextField
          label="안전재고"
          fullWidth
          name="safety_stock"
          onChange={handleSafetyStockChange}
          sx={{ mb: 3 }}
          error={validationErrors.safety_stock}
          helperText={
            validationErrors.safety_stock ? "0 이상의 정수를 입력하세요" : ""
          }
          inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
          required
        />
        <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1 }}>
          <SaveButton onClick={handleSave} />
          <CloseButton
            variant="outlined"
            onClick={() => table.setCreatingRow(null)}
            color="inherit"
          />
        </Box>
      </ModalContainer>
    </Modal>
  );
}

export default CreateItemModal;
